import { CommonModule } from '@angular/common';
import {
    Component,
    EventEmitter,
    HostListener,
    Input,
    Output,
} from '@angular/core';
import { ButtonModule } from 'primeng/button';
import { DialogModule } from 'primeng/dialog';

@Component({
    selector: 'app-popup',
    standalone: true,
    imports: [DialogModule, ButtonModule, CommonModule],
    templateUrl: './popup.component.html',
    styleUrl: './popup.component.scss',
})
export class PopupComponent {
    @Input() title: string = '';
    @Input() submitButtonText: string = '';
    @Input() cancelButtonText: string = '';
    @Input() visible: boolean = false;
    @Input() isSessionModel: boolean = false;
    @Input() id: number = 0;
    @Input() submitLoading: boolean = false;
    @Input() showSubmitBtn: boolean = true;
    @Input() showCancelBtn: boolean = true;
    @Input() submitDisabled: boolean = false;
    @Input() isDeletedPopup: boolean = false;
    @Input() isVersionConfirmationPopup: boolean = false;
    @Output() emitSubmit: EventEmitter<number> = new EventEmitter<number>(); // Emits no data
    @Output() closeModel: EventEmitter<boolean> = new EventEmitter<boolean>(); // Emits a boolean value

    /**
     * Closes the popup when escape key is pressed.
     */
    @HostListener('document:keydown.escape', ['$event'])
    onEscKey() {
        if (this.visible) {
            this.onClosePopup();
        }
    }

    /**
     * Emits the submit event with the ID of the item when submit btn is clicked.
     */
    onSubmit() {
        this.emitSubmit.emit(this.id);
    }

    /**
     * Closes the popup when the cancel button is clicked.
     * @param event - The click event.
     */
    onClosePopup(event?: Event) {
        if (this.visible) {
            event?.stopPropagation();
            this.visible = false;
            setTimeout(() => {
                this.closeModel.emit(false);
            }, 0);
        }
    }
}
